'use strict';
import isNumber from 'lodash/isNumber';
import {getCollection, getId} from '../../core-utilities/domain/ReduxUtils';
import {pauseTimer, queueIdGenerator, startTimer, stopTimer} from '../actions';
import {getActiveTimers} from '../reducers';
import {findByTarget} from '../reducers/activeTimersReducers';

export class TaskInfoTimerController {
  constructor(task, parentName, $ngRedux) {
    this.task = task;
    this.parentName = parentName;
    this.$ngRedux = $ngRedux;

    this.activeTimer = null;

    this.onStart = this.onStart.bind(this);
    this.onPause = this.onPause.bind(this);
    this.onStop = this.onStop.bind(this);
  }

  /**
   * @return {Observable<TaskInfoTimerProps>}
   */
  state$() {
    const baseProps = {
      isStopped: true,
      onStart: this.onStart,
      onPause: this.onPause,
      onStop: this.onStop,
    };

    const targetCollection = getCollection(this.task);
    const targetId = getId(this.task);

    return this.$ngRedux.state$
      .map(state => getActiveTimers(state).list)
      .distinctUntilChanged()
      .map(findByTarget(targetCollection, targetId))
      .distinctUntilChanged()
      .do(activeTimer => this.activeTimer = activeTimer)
      .map(activeTimer => propsFromModel(activeTimer, baseProps));
  }

  onStart(e) {
    const payload = TaskInfoTimerController.buildStartTimerPayload(this.task, this.parentName, this.activeTimer);

    if (payload === null) {
      // TODO: raise error
      return;
    }

    this.$ngRedux.dispatch(startTimer(payload));
  }

  /**
   * @param task
   * @param {String} parentName
   * @param [activeTimer]
   * @return {?StartTimerPayload}
   */
  static buildStartTimerPayload(task, parentName, activeTimer) {
    const payload = {
      targetCollection: getCollection(task),
      targetId: getId(task),
      targetName: task.name,
      parentName: parentName,
      startedAt: new Date().getTime(),
    };

    if (activeTimer) {
      if (activeTimer.startedAt) {
        // TODO: raise error

        return null;
      }

      payload.id = activeTimer.id;
      payload.requestId = activeTimer.requestId;
    } else {
      payload.requestId = queueIdGenerator();
    }

    return payload;
  }

  onPause(e) {
    if (!this.activeTimer) {
      // TODO: raise error
    } else {
      this.$ngRedux.dispatch(pauseTimer({
        id: this.activeTimer.id,
        requestId: this.activeTimer.requestId,
        endedAt: new Date().getTime(),
      }));
    }
  }

  onStop(e) {
    if (!this.activeTimer) {
      // TODO: raise error
    } else {
      this.$ngRedux.dispatch(stopTimer({
        id: this.activeTimer.id,
        requestId: this.activeTimer.requestId,
        endedAt: new Date().getTime(),
      }));
    }
  }
}

export function propsFromModel(model, baseProps) {
  if (!model) {
    return baseProps;
  } else {
    return {
      ...baseProps,
      ...model,
      isStopped: model.isStopped === true,
      isStarted: isNumber(model.startedAt),
    };
  }
}



// WEBPACK FOOTER //
// ./src/js/timers/controllers/TaskInfoTimerController.js